import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

export const Keyword = props => (
  <SvgIcon {...props}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Keyword-Up" fill="currentcolor" fillRule="nonzero">
        <g id="baseline-trending_up-24px" transform="translate(4.000000, 13.000000)">
          <polygon
            id="Shape"
            points="14 0 16.29 2.09916667 11.41 6.5725 7.41 2.90583333 0 9.7075 1.41 11 7.41 5.5 11.41 9.16666667 17.71 3.40083333 20 5.5 20 0"
          />
        </g>
        <g id="baseline-spellcheck-24px">
          <path
            d="M14.4692308,17 L17.3630769,17 L10.2876923,0 L7.71230769,0 L0.636923077,17 L3.53076923,17 L5.08153846,13.0769231 L12.8907692,13.0769231 L14.4692308,17 Z M6.13384615,10.4615385 L9,3.24307692 L11.8661538,10.4615385 L6.13384615,10.4615385 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
)

export default Keyword



// WEBPACK FOOTER //
// ./src/icons/Keyword.js